import { render, staticRenderFns } from "./TinForm.vue?vue&type=template&id=56b29f9f&scoped=true&"
import script from "./TinForm.vue?vue&type=script&lang=ts&"
export * from "./TinForm.vue?vue&type=script&lang=ts&"
import style0 from "./TinForm.vue?vue&type=style&index=0&id=56b29f9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b29f9f",
  null
  
)

export default component.exports